/** Mirrors BE `resolveSourceTypeLabelVi` (adjustment/constants.js) for offline fallback */
const SOURCE_TYPE_LABEL_VI = {
  RETAIL: 'Bán lẻ',
  DELIVERY_APP_LEGACY: 'Ứng dụng giao hàng',
  DELIVERY_APP: 'Ứng dụng giao hàng',
  DELIVERY_SHOPEE: 'Shopee Food',
  WHOLESALE: 'Bán buôn (B2B)',
};

export function getAdjustmentSourceTypeLabelVi(sourceType) {
  if (sourceType == null || sourceType === '') return null;
  return SOURCE_TYPE_LABEL_VI[sourceType] || String(sourceType);
}
